module.exports = __webpack_public_path__ + "img/424244_BDBBBE_8A898E_A3A4A9-256px.8ffeca57.png";